<template>
  <el-radio-group class="exam-checkbox-radio-box" v-model="checkValue[subjects.examQuestionsId]" :disabled="readOnly" @change="handleCheck">
    <el-radio v-for="item in subjects.options" :key="item.examQuestionsOptionsId" :label="item.examQuestionsOptionsId + '[-]' + item.name">
      <span> {{ item.option }}.{{ item.name }}</span>
      <i
        :class="[
          'iconfont right-icon',
          previewStatus && readOnly && subjects.result
            ? subjects.result.indexOf(item.examQuestionsOptionsId) > -1
              ? subjects.answer.indexOf(item.examQuestionsOptionsId) > -1
                ? 'icon-icon_gou'
                : 'icon-icon_wrong'
              : ''
            : 'icon-icon_gou',
        ]"
      ></i>
    </el-radio>
  </el-radio-group>
</template>

<script>
export default dsf.component({
  name: "DsfExamTrueFalse",
  mixins: [$mixins.examControl],
  ctrlCaption: "是非题",
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    previewStatus: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("exam-items-meta-data");
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    changeStatus(item) {
      console.log(this.checkValue, this.subjects.examQuestionsId);
      console.log(this.checkValue[this.subjects.examQuestionsId].indexOf(item.examQuestionsOptionsId) > -1);

      // {{  ? answerValue.indexOf(item.examQuestionsOptionsId) > -1 ? 'icon-icon_gou' : 'icon-icon_wrong' : '' }}

      return 1;
      // return this.confirmButtonText !== "确定" ? true : false;
    },
  },
});
</script>
